export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_de.003a88af11495a15.json"